import { ConfigProvider, notification } from "antd";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import "./App.css";

import { useAppSelector } from "./redux/hooks";
import AuthenticationScreen from "./screens/authentication";
import CheckoutPage from "./screens/checkoutScreen";
import DetailScreen from "./screens/detailScreen";
import Epaper from "./screens/epaper";
import Homescreen from "./screens/homescreen";
import PreviewScreen from "./screens/previewScreen";
import SubscribeScreen from "./screens/subscriptionScreen";
import Failed from "./screens/checkoutScreen/failed";
import PaymentSuccess from "./screens/checkoutScreen/sucess";
import ScreenshotBlocker from "./utils/screenshortblock";
function App() {
  const isAuthenticated = useAppSelector((state: any) => state?.User?.auth);
  const subscriptions = useAppSelector(
    (state: any) => state?.Subscription?.subscriptions
  );

  const checkEditionSubscription = (edition: string): boolean => {
    return subscriptions.some(
      (sub: any) =>
        sub.edition_type === edition &&
        sub.status === "active" &&
        new Date(sub.end_date) > new Date()
    );
  };

  const ProtectedDetailScreen = () => {
    const { edition } = useParams();
    const location = useLocation();

    if (!isAuthenticated) {
      return <Navigate to="/auth" state={{ from: location }} />;
    }

    if (!edition || !checkEditionSubscription(edition)) {
      notification.info({
        message: "information",
        description: "Please subscribe to access this edition",
      });
      return (
        <Navigate
          to="/subscribe"
          state={{
            message: "Please subscribe to access this edition",
            requestedEdition: edition,
          }}
        />
      );
    }

    return <DetailScreen />;
  };

  return (
    // <ScreenshotBlocker>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "NotoSansMalayalam-SemiBold",
          colorPrimary: "rgb(5, 118, 183)",
          borderRadius: 2,
        },
      }}
    >
      <Routes>
        <Route index element={<Homescreen />} />
        <Route path="/" element={<Homescreen />} />
        <Route path="/epaper" element={<Epaper />} />
        <Route
          path="/details/:edition/:date/:page/:id?"
          element={<ProtectedDetailScreen />}
        />
        <Route path="/preview" element={<PreviewScreen />} />
        <Route path="/CheckoutPage" element={<CheckoutPage />} />
        <Route path="/payment-success/:tid" element={<PaymentSuccess />} />
        <Route path="/payment-failure/:tid" element={<Failed />} />
        <Route path="/preview" element={<PreviewScreen />} />
        <Route path="/auth" element={<AuthenticationScreen />} />
        <Route
          path="/subscribe"
          element={
            isAuthenticated === "active" ? (
              <Navigate to="/" />
            ) : (
              <SubscribeScreen />
            )
          }
        />
      </Routes>
    </ConfigProvider>
    //  </ScreenshotBlocker>
  );
}

export default App;
